export default "__VITE_ASSET__eRUmorDe__"